import React from 'react';
import { Outlet } from 'react-router-dom';
import AgentSubNavigation from '../../components/agent-sub-navigation';

const View = () => (
  <>
    <AgentSubNavigation />
    <Outlet />
  </>
);

export default View;
